import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../environments/environment';

import { TOASTER_MSG } from './app-constants';
import { AuthAction } from './auth/store/auth.action';

@Injectable()
export class ActiveService {
    private options: { headers: HttpHeaders };
    private snackBar: MatSnackBar;
    protected baseUrl = undefined;

    constructor(
        public http: HttpClient,
        public store: Store
    ) {}

    private get url(): string {
        return this.baseUrl ?? environment.restUrl + '/v1/';
    }

    post(path: string, payload: any): Observable<any> {
        return this.http.post(this.url + path, payload).pipe(
            catchError((error) => {
                this.handleError(error);
                throw error;
            })
        );
    }

    get(path: string): Observable<any> {
        return this.http.get(this.url + path).pipe(
            catchError((error) => {
                this.handleError(error);
                throw error;
            })
        );
    }

    put(path: string, payload: any): Observable<any> {
        return this.http.put(this.url + path, payload).pipe(
            catchError((error) => {
                this.handleError(error);
                throw error;
            })
        );
    }

    delete(path: string): Observable<any> {
        return this.http.delete(this.url + path).pipe(
            catchError((error) => {
                this.handleError(error);
                throw error;
            })
        );
    }

    handleError(err) {
        //  if (err.status === 422) {
        //  this.store.dispatch(new Navigate(['/auth/pin']));
        // } else
        if (err.status === 401) {
            this.store.dispatch(new AuthAction.MainLogout());
            this.store.dispatch(new Navigate(['/auth/login']));
        } else if (err.status === 403) {
            this.snackBar.open(TOASTER_MSG.general.unableToPerformAction.display, 'X', {
                duration: 5000,
            });
        }
    }
}
